import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
} from "@mui/material";
import { toast } from "react-toastify";
import BuildIcon from "@mui/icons-material/Build";
import VerifiedIcon from "@mui/icons-material/Verified";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import {
  useGetStatesQuery,
  useGetCitiesQuery,
  useLeadGenerationMutation,
  useGetWorkshopsQuery,
} from "../../Services/leads/LeadGeneration";
import ChooseUs from "./UpdatedUi/ChooseUs";
import Footer from "./UpdatedUi/Footer";
import { CurrencyRupee } from "@mui/icons-material";
import { isAutoServicesTenant } from "../../utils/tenantBranding";

interface FormData {
  name: string;
  email: string;
  mobile: string;
  state: string;
  city: string;
  workshop: string;
  workshop_id: number | null;
}

interface State {
  name: string;
}

interface City {
  name: string;
}

const LeadGenerationPage: React.FC = () => {
  const navigate = useNavigate();
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    workshop: "",
    workshop_id: null,
  });
  const [selectedStateName, setSelectedStateName] = useState<string>("");
  const [selectedCityName, setSelectedCityName] = useState<string>("");
  const [states, setStates] = useState<State[]>([]);
  const [cities, setCities] = useState<City[]>([]);
  const [workshops, setWorkshops] = useState<any>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: getStatesData, isLoading: isStateLoading } = useGetStatesQuery(
    {},
  );
  const { data: getCitiesData, isLoading: isCityLoading } = useGetCitiesQuery(
    selectedStateName,
    { skip: !selectedStateName },
  );
  const { data: getWorkshopData, isLoading: isWorkshopLoading } =
    useGetWorkshopsQuery(
      { selectedStateId: selectedStateName, selectedCityId: selectedCityName },
      { skip: !selectedStateName || !selectedCityName },
    );

  const [triggerLeadGeneration] = useLeadGenerationMutation();

  console.log(selectedStateName, "selectedStateName");
  console.log(selectedCityName, "selectedCityName");

  useEffect(() => {
    if (getStatesData) {
      setStates(getStatesData?.results || []);
    }
  }, [getStatesData]);

  useEffect(() => {
    if (getCitiesData) {
      setCities(getCitiesData?.results || []);
    } else {
      setCities([]);
    }
  }, [getCitiesData]);

  useEffect(() => {
    if (getWorkshopData) {
      setWorkshops(getWorkshopData?.results || []);
    } else {
      setWorkshops([]);
    }
  }, [getWorkshopData]);

  console.log(getWorkshopData, "getWorkshopData");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const val = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: val }));
    } else if (name === "state") {
      setSelectedStateName(value);
      setFormData((prev) => ({
        ...prev,
        state: value,
        city: "",
        workshop: "",
        workshop_id: null,
      }));
      setSelectedCityName("");
    } else if (name === "city") {
      setSelectedCityName(value);
      setFormData((prev) => ({
        ...prev,
        city: value,
        workshop: "",
        workshop_id: null,
      }));
    } else if (name === "workshop") {
      const selectedWorkshop = workshops.find((ws: any) => ws.name === value);
      const workshopId = selectedWorkshop ? selectedWorkshop.id : null;

      // console.log("Selected Workshop:", selectedWorkshop);
      // console.log("Workshop ID:", workshopId);

      setFormData((prev) => ({
        ...prev,
        workshop: value,
        workshop_id: workshopId,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile: string): boolean => {
    return /^[0-9]{10}$/.test(mobile);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Name is required");
      return;
    }

    if (!formData.mobile.trim()) {
      toast.error("Mobile number is required");
      return;
    }

    if (!validateMobile(formData.mobile.trim())) {
      toast.error("Enter a valid 10-digit mobile number");
      return;
    }

    if (!formData.state.trim()) {
      toast.error("State is required");
      return;
    }

    if (!formData.city.trim()) {
      toast.error("City is required");
      return;
    }

    if (workshops.length > 0) {
      if (!formData.workshop.trim() || !formData.workshop_id) {
        toast.error("Workshop is required");
        return;
      }
    }

    if (formData.email.trim() && !validateEmail(formData.email.trim())) {
      toast.error("Enter a valid email address");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload: any = {
        name: formData.name.trim(),
        mobile: formData.mobile.trim(),
        state: formData.state.trim(),
        city: formData.city.trim(),
      };

      if (workshops.length > 0 && formData.workshop_id) {
        payload.workshop_id = formData.workshop_id?.toString() || "";
      }

      if (formData.email.trim()) {
        payload.email = formData.email.trim();
      }

      console.log("Payload being sent:", payload);

      await triggerLeadGeneration(payload).unwrap();
      sessionStorage.removeItem("hasReloaded");
      navigate("/thank-you");
    } catch (error: any) {
      console.error("Error submitting form:", error);
      if (error?.data) {
        const errors = error.data;
        if (errors.state && Array.isArray(errors.state)) {
          toast.error(errors.state[0] || "State is required");
        } else if (errors.city && Array.isArray(errors.city)) {
          toast.error(errors.city[0] || "City is required");
        } else if (errors.name && Array.isArray(errors.name)) {
          toast.error(errors.name[0] || "Name is required");
        } else if (errors.mobile && Array.isArray(errors.mobile)) {
          toast.error(errors.mobile[0] || "Mobile number is required");
        } else if (errors.email && Array.isArray(errors.email)) {
          toast.error(errors.email[0] || "Invalid email address");
        } else if (errors.workshop && Array.isArray(errors.workshop)) {
          toast.error(errors.workshop[0] || "Workshop selection error");
        } else if (errors.detail) {
          toast.error(errors.detail);
        } else {
          const firstErrorKey = Object.keys(errors)[0];
          const firstError = errors[firstErrorKey];
          if (Array.isArray(firstError) && firstError.length > 0) {
            toast.error(firstError[0]);
          } else {
            toast.error("Something went wrong. Please try again.");
          }
        }
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNavigateHome = () => {
    navigate("/home");
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const keyFeatures = [
    {
      icon: <BuildIcon sx={{ fontSize: 40, color: "#FF5722" }} />,
      title: "Wide network of certified workshops",
    },
    {
      icon: <VerifiedIcon sx={{ fontSize: 40, color: "#FF5722" }} />,
      title: "Genuine parts with warranty",
    },
    {
      icon: <GroupIcon sx={{ fontSize: 40, color: "#FF5722" }} />,
      title: "Skilled and trained technicians",
    },
    {
      icon: <CurrencyRupee sx={{ fontSize: 40, color: "#FF5722" }} />,
      title: "Transparent pricing and quick turnaround",
    },
  ];

  return (
    <>
      <div className="home-page-cont">
        {/* Header with Logo and Home Button */}
        <Box
          sx={{
            padding: { xs: "5px 5px", sm: "5px 5px", md: "15px 15px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Logo - Clickable */}
          <Box
            onClick={handleNavigateHome}
            sx={{
              maxWidth: { xs: "150px", sm: "200px", md: "250px" },
              width: "100%",
              cursor: "pointer",
              transition: "transform 0.2s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <Box
              component="img"
              src={
                autoServicesBranding
                  ? "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg"
                  : "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearlogo.png"
              }
              alt={autoServicesBranding ? "Auto Services logo" : "EUROREPAR logo"}
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>

          {/* Home Button */}
          <IconButton
            onClick={handleNavigateHome}
            sx={{
              bgcolor: "#FF5722",
              color: "white",
              "&:hover": {
                bgcolor: "#E64A19",
                transform: "scale(1.1)",
              },
              transition: "all 0.3s ease",
              boxShadow: "0 4px 12px rgba(255, 87, 34, 0.3)",
            }}
            aria-label="Go to home"
          >
            <HomeIcon />
          </IconButton>
        </Box>

        {/* Hero Banner */}
        <Box
          sx={{
            width: "100%",
            height: { xs: "auto", md: "180px" },
            minHeight: { xs: "120px", sm: "140px" },
            bgcolor: "#FF5722",
            borderRadius: 0,
            mt: { xs: 1, sm: 1, md: 1 },
            mb: { xs: 2, sm: 2, md: 2 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #FF5722 0%, #E64A19 100%)",
            boxShadow: "0 8px 32px rgba(255, 87, 34, 0.4)",
            position: "relative",
            overflow: "hidden",
            py: { xs: 3, sm: 4, md: 0 },
            px: { xs: 2, sm: 3 },
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at 30% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              px: { xs: 2, sm: 3, md: 4 },
              textAlign: "center",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "white",
                fontFamily: "Karbon",
                fontWeight: 700,
                textAlign: "center",
                lineHeight: { xs: 1.2, sm: 1.3 },
                mt: { xs: 1, md: 2 },
                mb: { xs: 1, md: 2 },
                textShadow: "0 2px 8px rgba(0,0,0,0.2)",
              }}
            >
              Welcome to Our Service
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontFamily: "Karbon",
                fontWeight: 400,
                textAlign: "center",
                fontSize: { xs: "16px", md: "20px" },
                lineHeight: 1.4,
                maxWidth: "600px",
                mx: "auto",
              }}
            >
              Professional car care and maintenance services you can trust
            </Typography>
          </Box>
        </Box>

        <Container
          maxWidth="xl"
          sx={{ mb: { xs: 4, sm: 6, md: 8 }, px: { xs: 2, sm: 3 } }}
        >
          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
            {/* Left Section - Image/Video */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                  height: "100%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                    minHeight: { xs: "300px", md: "600px" },
                    background:
                      "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={
                      autoServicesBranding
                        ? "https://media.istockphoto.com/id/1347150429/photo/professional-mechanic-working-on-the-engine-of-the-car-in-the-garage.jpg?s=612x612&w=0&k=20&c=5zlDGgLNNaWsp_jq_L1AsGT85wrzpdl3kVH-75S-zTU="
                        : "https://botgo.s3.ap-south-1.amazonaws.com/13445141765198324761-Eurorepar -lead generation form image.jpg"
                    }
                    alt={autoServicesBranding ? "Auto Services" : "Eurorepar Car Service"}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  />

                  {/* Info Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)",
                      p: { xs: 2.5, sm: 3, md: 4 },
                      zIndex: 1,
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        color: "white",
                        fontFamily: "Karbon",
                        fontWeight: 700,
                        mb: 1,
                        fontSize: { xs: "18px", sm: "20px", md: "24px" },
                      }}
                    >
                      Experience Premium Car Care
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "rgba(255,255,255,0.9)",
                        fontFamily: "Karbon",
                        fontSize: { xs: "13px", sm: "14px", md: "16px" },
                      }}
                    >
                      We transform your vehicle with expert service
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>

            {/* Right Section - Enquiry Form */}
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                  p: { xs: 2.5, sm: 4, md: 5 },
                  height: "100%",
                  background:
                    "linear-gradient(to bottom, #ffffff 0%, #fafafa 100%)",
                }}
              >
                <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontFamily: "Karbon",
                      fontWeight: 700,
                      mb: 1,
                      color: "#1a1a1a",
                      fontSize: { xs: "24px", sm: "28px", md: "36px" },
                    }}
                  >
                    Get Your Car Serviced Today
                  </Typography>
                  <Box
                    sx={{
                      width: "60px",
                      height: "4px",
                      bgcolor: "#FF5722",
                      borderRadius: "2px",
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: "Karbon",
                      color: "#666",
                      fontSize: { xs: "14px", md: "15px" },
                    }}
                  >
                    Fill in your details and we'll get back to you soon
                  </Typography>
                </Box>

                <div
                  onSubmit={handleSubmit}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontFamily: "Karbon",
                        bgcolor: "white",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                          borderRadius: "10px",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": { borderColor: "#FF5722" },
                        "&.Mui-focused fieldset": {
                          borderColor: "#FF5722",
                          borderWidth: "2px",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "#333",
                        fontFamily: "Karbon",
                        py: 1.8,
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Karbon",
                        color: "#666666",
                        "&.Mui-focused": { color: "#FF5722", fontWeight: 600 },
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    label="Email (Optional)"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontFamily: "Karbon",
                        bgcolor: "white",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                          borderRadius: "10px",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": { borderColor: "#FF5722" },
                        "&.Mui-focused fieldset": {
                          borderColor: "#FF5722",
                          borderWidth: "2px",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "#333",
                        fontFamily: "Karbon",
                        py: 1.8,
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Karbon",
                        color: "#666666",
                        "&.Mui-focused": { color: "#FF5722", fontWeight: 600 },
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    label="Contact no / Whatsapp no"
                    name="mobile"
                    type="tel"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontFamily: "Karbon",
                        bgcolor: "white",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                          borderRadius: "10px",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": { borderColor: "#FF5722" },
                        "&.Mui-focused fieldset": {
                          borderColor: "#FF5722",
                          borderWidth: "2px",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "#333",
                        fontFamily: "Karbon",
                        py: 1.8,
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Karbon",
                        color: "#666666",
                        "&.Mui-focused": { color: "#FF5722", fontWeight: 600 },
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    select
                    label="State"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                    disabled={isStateLoading}
                    SelectProps={{ MenuProps: MenuProps }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontFamily: "Karbon",
                        bgcolor: "white",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                          borderRadius: "10px",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": { borderColor: "#FF5722" },
                        "&.Mui-focused fieldset": {
                          borderColor: "#FF5722",
                          borderWidth: "2px",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "#333",
                        fontFamily: "Karbon",
                        py: 1.8,
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Karbon",
                        color: "#666666",
                        "&.Mui-focused": { color: "#FF5722", fontWeight: 600 },
                      },
                    }}
                  >
                    {isStateLoading ? (
                      <MenuItem value="">Loading...</MenuItem>
                    ) : (
                      states.map((state, index) => (
                        <MenuItem key={index} value={state.name}>
                          {state.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>

                  <TextField
                    fullWidth
                    select
                    label="City"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    disabled={isCityLoading || !formData.state}
                    SelectProps={{ MenuProps: MenuProps }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        fontFamily: "Karbon",
                        bgcolor: "white",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                          borderRadius: "10px",
                          borderWidth: "2px",
                        },
                        "&:hover fieldset": { borderColor: "#FF5722" },
                        "&.Mui-focused fieldset": {
                          borderColor: "#FF5722",
                          borderWidth: "2px",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        color: "#333",
                        fontFamily: "Karbon",
                        py: 1.8,
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "Karbon",
                        color: "#666666",
                        "&.Mui-focused": { color: "#FF5722", fontWeight: 600 },
                      },
                    }}
                  >
                    {!formData.state ? (
                      <MenuItem value="">Please select a state first</MenuItem>
                    ) : isCityLoading ? (
                      <MenuItem value="">Loading...</MenuItem>
                    ) : (
                      cities.map((city, index) => (
                        <MenuItem key={index} value={city.name}>
                          {city.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>

                  {workshops?.length > 0 && (
                    <TextField
                      fullWidth
                      select
                      label="Workshop"
                      name="workshop"
                      value={formData.workshop}
                      onChange={handleChange}
                      required
                      disabled={isWorkshopLoading || !formData.city}
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 300,
                              width: 400,
                            },
                          },
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          fontFamily: "Karbon",
                          bgcolor: "white",
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                            borderRadius: "10px",
                            borderWidth: "2px",
                          },
                          "&:hover fieldset": { borderColor: "#FF5722" },
                          "&.Mui-focused fieldset": {
                            borderColor: "#FF5722",
                            borderWidth: "2px",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          color: "#333",
                          fontFamily: "Karbon",
                          py: 1.8,
                        },
                        "& .MuiInputLabel-root": {
                          fontFamily: "Karbon",
                          color: "#666666",
                          "&.Mui-focused": {
                            color: "#FF5722",
                            fontWeight: 600,
                          },
                        },
                      }}
                    >
                      {!formData.city ? (
                        <MenuItem value="">Please select a city first</MenuItem>
                      ) : isWorkshopLoading ? (
                        <MenuItem value="">Loading workshops...</MenuItem>
                      ) : workshops?.length === 0 ? (
                        <MenuItem value="">No workshops available</MenuItem>
                      ) : (
                        workshops?.map((workshop: any) => (
                          <MenuItem
                            key={workshop.id}
                            value={workshop.name}
                            sx={{
                              whiteSpace: "normal",
                              py: 2,
                              px: 2,
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  fontFamily: "Karbon",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                  color: "#1a1a1a",
                                  mb: 0.5,
                                }}
                              >
                                {workshop.name}
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Karbon",
                                  fontSize: "13px",
                                  color: "#666",
                                  lineHeight: 1.4,
                                }}
                              >
                                {workshop.address}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))
                      )}
                    </TextField>
                  )}

                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    size="large"
                    disabled={isSubmitting}
                    onClick={(e: any) => handleSubmit(e)}
                    sx={{
                      mt: 2,
                      py: 2,
                      bgcolor: "#FF5722",
                      borderRadius: "10px",
                      fontFamily: "Karbon",
                      fontSize: "17px",
                      fontWeight: 700,
                      textTransform: "none",
                      boxShadow: "0 6px 20px rgba(255, 87, 34, 0.4)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        bgcolor: "#E64A19",
                        boxShadow: "0 8px 24px rgba(255, 87, 34, 0.5)",
                        transform: "translateY(-2px)",
                      },
                      "&:disabled": {
                        bgcolor: "#FFCCBC",
                        color: "#FFFFFF",
                        boxShadow: "none",
                      },
                    }}
                  >
                    {isSubmitting
                      ? "Sending..."
                      : "Book Your Service Appointment"}
                  </Button>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Container>

        {/* Key Features Section */}
        <Box sx={{ bgcolor: "#f8f9fa", py: 8 }}>
          <Container maxWidth="xl">
            <Box sx={{ textAlign: "center", mb: 6 }}>
              <Typography
                variant="h3"
                sx={{
                  fontFamily: "Karbon",
                  fontWeight: 700,
                  color: "#1a1a1a",
                  fontSize: { xs: "32px", md: "44px" },
                  mb: 1,
                }}
              >
                {autoServicesBranding ? "Auto Services Key Features" : "Eurorepar Key Features"}
              </Typography>
              <Box
                sx={{
                  width: "80px",
                  height: "4px",
                  bgcolor: "#FF5722",
                  borderRadius: "2px",
                  mx: "auto",
                  mb: 2,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Karbon",
                  color: "#666",
                  fontSize: "16px",
                  maxWidth: "600px",
                  mx: "auto",
                }}
              >
                Discover what makes us the preferred choice for car care
              </Typography>
            </Box>

            <Grid container spacing={3}>
              {keyFeatures.map((feature, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      height: "100%",
                      borderRadius: 3,
                      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      border: "1px solid rgba(255, 87, 34, 0.1)",
                      "&:hover": {
                        transform: "translateY(-12px)",
                        boxShadow: "0 12px 32px rgba(255, 87, 34, 0.2)",
                        borderColor: "#FF5722",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        p: 4,
                      }}
                    >
                      <Box
                        sx={{
                          mb: 3,
                          p: 2,
                          borderRadius: "50%",
                          bgcolor: "rgba(255, 87, 34, 0.1)",
                          transition: "all 0.3s ease",
                          ".MuiCard-root:hover &": {
                            bgcolor: "rgba(255, 87, 34, 0.15)",
                            transform: "scale(1.1)",
                          },
                        }}
                      >
                        {feature.icon}
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontFamily: "Karbon",
                          fontWeight: 600,
                          color: "#1a1a1a",
                          fontSize: "18px",
                          lineHeight: 1.4,
                        }}
                      >
                        {feature.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        <div className="mt-2">
          <ChooseUs />
        </div>

        {/* <div>
          <HowItWorks setIsCartOpen={setIsCartOpen} />
        </div> */}

        {/* Footer Component */}
        <div className="mt-2">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default LeadGenerationPage;
